import { SeoMapper } from '@search/router/src';

export const buildEpochMapper = new SeoMapper('buildEpochMapper', {
    unknown: 'UNKNOWN',
    stalin: 'STALIN',
    brezhnev: 'BREZHNEV',
    khrushchev: 'KHRUSHCHEV'
} as const);
